/* src/app/request-form/add-request/add-request.component.scss */
@media (min-width: 375px) {
  #AddRequestInputs {
    min-width: 318px;
  }
}
#AddRequestInputs .error {
  position: relative;
}
#AddRequestInputs .error label {
  color: #C91913;
}
#AddRequestInputs .error ::ng-deep input {
  border-color: #C91913;
}
#AddRequestInputs .error .error-icon::after {
  font-family: "upsicons", fantasy !important;
  content: "\e638" !important;
  color: #C91913;
  position: absolute;
  bottom: 1.6rem;
  right: 1rem;
  font-size: 16px;
}
/*# sourceMappingURL=add-request.component.css.map */
